"use client";

import { useState } from "react";
import { useUserLists } from "@/components/UserListsProvider";
import type { Product } from "@/lib/catalog";

function CompareIcon() {
  return (
    <svg viewBox="0 0 24 24" aria-hidden="true">
      <path d="M6 18V9" fill="none" stroke="currentColor" strokeLinecap="round" strokeWidth="1.8" />
      <path d="M12 18V5" fill="none" stroke="currentColor" strokeLinecap="round" strokeWidth="1.8" />
      <path d="M18 18v-7" fill="none" stroke="currentColor" strokeLinecap="round" strokeWidth="1.8" />
    </svg>
  );
}

type ProductCompareButtonProps = {
  product: Product;
  variant?: "icon" | "inline";
  className?: string;
};

export function ProductCompareButton({
  product,
  variant = "icon",
  className
}: ProductCompareButtonProps) {
  const { isCompared, toggleCompare } = useUserLists();
  const [limitReached, setLimitReached] = useState(false);
  const active = isCompared(product.slug);
  const buttonLabel = active ? "Убрать из сравнения" : "Добавить в сравнение";

  return (
    <button
      type="button"
      aria-label={limitReached ? "Можно сравнивать не больше 3 товаров" : buttonLabel}
      aria-pressed={active}
      title={limitReached ? "Можно сравнивать не больше 3 товаров" : buttonLabel}
      className={`saved-toggle saved-toggle--${variant} ${active ? "is-active" : ""} ${limitReached ? "is-warning" : ""} ${className ?? ""}`.trim()}
      onClick={(event) => {
        event.preventDefault();
        event.stopPropagation();

        const result = toggleCompare(product);
        if (!result.ok) {
          setLimitReached(true);
          window.setTimeout(() => setLimitReached(false), 1800);
          return;
        }

        setLimitReached(false);
      }}
    >
      <CompareIcon />
      {variant === "inline" ? (
        <span>{active ? "В сравнении" : limitReached ? "Максимум 3" : "Сравнить"}</span>
      ) : null}
    </button>
  );
}
